import React from 'react';
import EditableField from './EditableField';
import Tooltip from './Tooltip';
import './Stats.css';

const Vitals = ({ hitPoints, hitDice, deathSaves, updateCharacter, proficiencyBonus }) => {
    return (
        <div className="vitals-container">
            <div className="stat-block">
                <label>Hit Points</label>
                <div className="hp-values">
                    <EditableField path={['hitPoints', 'current']} value={hitPoints.current} updateCharacter={updateCharacter} /> /
                    <EditableField path={['hitPoints', 'max']} value={hitPoints.max} updateCharacter={updateCharacter} />
                </div>
                <div className="hp-controls">
                    {/* Future: Add Heal/Damage buttons here? */}
                </div>
            </div>

            <div className="stat-block">
                <label>Temp HP</label>
                <EditableField path={['hitPoints', 'temp']} value={hitPoints.temp} updateCharacter={updateCharacter} />
            </div>

            <div className="stat-block">
                <label>Hit Dice</label>
                <EditableField path={['hitDice']} value={hitDice} updateCharacter={updateCharacter} />
            </div>

            <div className="stat-block">
                <label>Death Saves</label>
                <div className="death-saves">
                    <div className="ds-row">
                        <span>Successes</span>
                        <EditableField path={['deathSaves', 'successes']} value={deathSaves.successes} updateCharacter={updateCharacter} />
                    </div>
                    <div className="ds-row">
                        <span>Failures</span>
                        <EditableField path={['deathSaves', 'failures']} value={deathSaves.failures} updateCharacter={updateCharacter} />
                    </div>
                </div>
            </div>

            <div className="stat-block">
                <label>
                    Proficiency Bonus
                    <Tooltip text="Bonus added to skills and saves you are proficient in. Based on Level.">
                        <span className="help-icon">?</span>
                    </Tooltip>
                </label>
                <div className="value">+{proficiencyBonus}</div>
            </div>
        </div>
    );
};

export default Vitals;
